<template>
  <div
    class="modal fade"
    tabindex="-1"
    id="add-customer-modal"
    ref="newTargetModalRef"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered mw-950px">
      <div class="modal-content rounded">
        <BlockUI :loading="block" />
        <div class="modal-header">
          <h5 class="modal-title">{{ translate(title) }}</h5>

          <!--begin::Close-->
          <div
            class="btn btn-icon btn-sm btn-active-light-primary ms-2 text-dark"
            @click="cancelForm"
            aria-label="Close"
          >
            <i class="bi bi-x-lg"></i>
          </div>
          <!--end::Close-->
        </div>

        <div class="modal-body rounded p-0">
          <div>
            <div class="card">
              <div id="add-company" class="collapse show">
                <!--begin::Form-->
                <Form
                  v-slot="{ errors }"
                  ref="refForm"
                  id="add-company-form"
                  class="form p-10 rounded-bottom"
                  novalidate="novalidate"
                  @submit="onSubmit"
                  :validation-schema="companyValidator"
                  style="padding-bottom: 1.5rem !important; background: #fbfbfb"
                >
                  <!-- // ! Şirket Adı -->
                  <div class="row mb-4">
                    <label
                      class="col-lg-4 col-form-label required fw-bold fs-6"
                      >{{ translate("CustomerAdd_CompanyName") }}</label
                    >
                    <div class="col-lg-8 fv-row d-v-container">
                      <div class="fv-plugins-message-container d-v-content">
                        <div class="fv-help-block ms-2 v-element">
                          <ErrorMessage name="customerName" />
                        </div>
                      </div>
                      <Field
                        type="text"
                        name="customerName"
                        class="form-control form-control-lg fs-6"
                        :class="
                          errors['customerName'] !== undefined
                            ? 'v-invalid'
                            : ''
                        "
                        :placeholder="translate('CustomerAdd_CompanyName')"
                        v-model.trim="customer.name"
                      />
                    </div>
                  </div>
                  <!-- // ! Şirket Adı End -->
                  <!-- // ? Yetkili Personel Adı -->
                  <div class="row">
                    <!--begin::Label-->
                    <label
                      class="col-lg-4 col-form-label required fw-bold fs-6"
                      >{{ translate("CustomerAdd_OfficialPersonnel") }}</label
                    >
                    <!--end::Label-->

                    <!--begin::Col-->
                    <div class="col-lg-8">
                      <!--begin::Row-->
                      <div class="row">
                        <!--begin::Col-->
                        <div class="col-lg-6 fv-row d-v-container">
                          <div class="fv-plugins-message-container d-v-content">
                            <div class="fv-help-block ms-2 v-element">
                              <ErrorMessage name="fname" />
                            </div>
                          </div>
                          <Field
                            type="text"
                            name="fname"
                            :class="
                              errors['fname'] !== undefined ? 'v-invalid' : ''
                            "
                            class="form-control form-control-lg fs-6"
                            :placeholder="translate('FirstName')"
                            v-model.trim="customer.firstname"
                          />
                        </div>
                        <!--end::Col-->

                        <!--begin::Col-->
                        <div class="col-lg-6 fv-row d-v-container">
                          <div class="fv-plugins-message-container d-v-content">
                            <div class="fv-help-block ms-2 v-element">
                              <ErrorMessage name="lname" />
                            </div>
                          </div>
                          <Field
                            type="text"
                            name="lname"
                            :class="
                              errors['lname'] !== undefined ? 'v-invalid' : ''
                            "
                            class="form-control form-control-lg fs-6"
                            :placeholder="translate('LastName')"
                            v-model.trim="customer.lastname"
                          />
                        </div>
                        <!--end::Col-->
                      </div>
                      <!--end::Row-->
                    </div>
                    <!--end::Col-->
                  </div>
                  <!-- // ? Yetkili Personel Adı End -->

                  <!-- // * Yetkili Personel Email -->
                  <div class="row mb-4 mt-4">
                    <label
                      class="col-lg-4 col-form-label required fw-bold fs-6"
                      >{{ translate("EMail") }}</label
                    >

                    <div class="col-lg-8 fv-row d-v-container">
                      <div class="fv-plugins-message-container d-v-content">
                        <div class="fv-help-block ms-2 v-element">
                          <ErrorMessage name="email" />
                        </div>
                      </div>
                      <Field
                        type="text"
                        name="email"
                        :class="
                          errors['email'] !== undefined ? 'v-invalid' : ''
                        "
                        class="form-control form-control-lg fs-6"
                        :placeholder="translate('EMail')"
                        v-model.trim="customer.email"
                      />
                    </div>
                  </div>
                  <!-- // * Yetkili Personel Email End -->

                  <!-- // ? Telefon Bilgisi -->
                  <div class="row mb-4">
                    <label class="col-lg-4 col-form-label fw-bold fs-6">{{
                      translate("PhoneNumber")
                    }}</label>
                    <div class="col-lg-8 fv-row">
                      <Field
                        type="text"
                        name="phone"
                        class="form-control form-control-lg fs-6"
                        :placeholder="translate('PhoneNumber')"
                        v-model="customer.phoneNumber"
                      />
                    </div>
                  </div>
                  <!-- // ? Telefon Bilgisi End -->

                  <!-- // ! Adres Bilgileri -->
                  <div class="row mb-4">
                    <label class="col-lg-4 col-form-label fw-bold fs-6">{{
                      translate("Address")
                    }}</label>
                    <div class="col-lg-8">
                      <!--begin::Row-->
                      <div class="row">
                        <!--begin::Col-->
                        <div class="col-lg-4 fv-row">
                          <Dropdown
                            class="mb-3"
                            :filter="!platform"
                            :emptyFilterMessage="translate('No_Records')"
                            v-model="customer.countryId"
                            :options="CountryList"
                            optionLabel="Value"
                            optionValue="Id"
                            :placeholder="translate('CountrySelect')"
                            style="padding: 5px !important"
                            @change="getCity"
                            appendTo="self"
                          >
                            <template v-slot:indicator>
                              <div
                                class="p-dropdown-trigger"
                                role="button"
                                aria-haspopup="listbox"
                                aria-expanded="false"
                              >
                                <span
                                  class="p-dropdown-trigger-icon pi pi-chevron-down"
                                ></span>
                              </div>

                              <i
                                v-if="customer.countryId === 0 ? false : true"
                                class="p-dropdown-clear-icon pi pi-times"
                                @click="(customer.countryId = 0), getCity()"
                              ></i>
                            </template>
                          </Dropdown>
                        </div>
                        <div class="col-lg-4 fv-row">
                          <Dropdown
                            class="mb-3"
                            :filter="!platform"
                            :emptyFilterMessage="translate('No_Records')"
                            v-model="customer.cityId"
                            :options="CityList"
                            optionLabel="Value"
                            optionValue="Id"
                            :placeholder="translate('CitySelect')"
                            style="padding: 5px !important"
                            @change="getDistrict"
                            appendTo="self"
                          >
                            <template v-slot:indicator>
                              <div
                                class="p-dropdown-trigger"
                                role="button"
                                aria-haspopup="listbox"
                                aria-expanded="false"
                              >
                                <span
                                  class="p-dropdown-trigger-icon pi pi-chevron-down"
                                ></span>
                              </div>

                              <i
                                v-if="customer.cityId === 0 ? false : true"
                                class="p-dropdown-clear-icon pi pi-times"
                                @click="(customer.cityId = 0), getDistrict()"
                              ></i>
                            </template>
                          </Dropdown>
                        </div>
                        <div class="col-lg-4 fv-row">
                          <Dropdown
                            class="mb-3"
                            :filter="!platform"
                            :emptyFilterMessage="translate('No_Records')"
                            v-model="customer.districtId"
                            :options="DistrictList"
                            optionLabel="Value"
                            optionValue="Id"
                            :placeholder="translate('DistrictSelect')"
                            style="padding: 5px !important"
                            appendTo="self"
                          >
                            <template v-slot:indicator>
                              <div
                                class="p-dropdown-trigger"
                                role="button"
                                aria-haspopup="listbox"
                                aria-expanded="false"
                              >
                                <span
                                  class="p-dropdown-trigger-icon pi pi-chevron-down"
                                ></span>
                              </div>

                              <i
                                v-if="customer.districtId === 0 ? false : true"
                                class="p-dropdown-clear-icon pi pi-times"
                                @click="customer.districtId = 0"
                              ></i>
                            </template>
                          </Dropdown>
                        </div>

                        <!--end::Col-->
                      </div>
                      <!--end::Row-->
                    </div>
                  </div>
                  <div class="row mb-4 justify-content-end">
                    <div class="col-lg-8 fv-row">
                      <input
                        type="text"
                        name="adress-detay"
                        class="form-control form-control-lg fs-6"
                        :placeholder="translate('AddressDetail')"
                        v-model.trim="customer.address"
                      />
                    </div>
                  </div>
                  <!-- // ! Adres Bilgileri End -->

                  <!-- // ? Firma Detay Bilgileri -->
                  <div class="row mb-4">
                    <label class="col-lg-4 col-form-label fw-bold fs-6">{{
                      translate("CompanyDetail")
                    }}</label>
                    <div class="col-lg-8 fv-row">
                      <textarea
                        name="description"
                        class="form-control form-control-lg fs-6"
                        :placeholder="translate('CompanyDetail')"
                        v-model.trim="customer.description"
                      />
                    </div>
                  </div>
                  <!-- // ? Firma Detay Bilgileri End -->
                  <div class="row justify-content-end">
                    <div class="col-lg-8 fv-row">
                      <div
                        class="form-check form-check-custom form-check-solid"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="check-remember"
                          v-model="customer.published"
                        />
                        <div class="d-flex flex-column position-relative w-100">
                          <label
                            class="form-check-label col-form-label fw-bold p-0 mt-2"
                            for="check-remember"
                            style="margin-bottom: 15px"
                          >
                            {{ translate("customer_modal_check_label") }}
                          </label>
                          <label
                            class="form-check-label col-form-label fw-bold fs-7 p-0 text-gray-500"
                            for="check-remember"
                            style="position: absolute; margin-top: 20px"
                          >
                            {{
                              translate(
                                "customer_modal_check_label_description"
                              )
                            }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="d-flex justify-content-end p-0"
                    style="padding-top: 1.5rem !important"
                  >
                    <button
                      @click="cancelForm"
                      type="reset"
                      class="btn btn-white btn-active-light me-2 border btn-sm fs-6"
                    >
                      {{ translate("Cancel") }}
                    </button>

                    <button
                      v-if="props.UpdateItem === null"
                      type="submit"
                      id="kt_add_customer_submit"
                      class="btn btn-primary border btn-sm fs-6"
                      :disabled="loading"
                    >
                      <div
                        v-if="loading"
                        class="spinner-border spinner-border-sm mx-1"
                      ></div>
                      <span class="indicator-label">
                        {{ translate("Add") }}
                      </span>
                    </button>
                    <a
                      v-else
                      @click="updateCustomer"
                      :class="`btn btn-primary border btn-sm fs-6 ${
                        Object.keys(errors).length > 0 || loading
                          ? 'disabled'
                          : ''
                      }`"
                    >
                      <div
                        v-if="loading"
                        class="spinner-border spinner-border-sm mx-1"
                      ></div>
                      <span class="indicator-label">
                        {{ translate("Save") }}
                      </span>
                    </a>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  computed,
  reactive,
  ref,
  defineProps,
  defineEmits,
  watch,
  onMounted,
} from "vue";
import { hideModal } from "@/core/helpers/dom";
import * as Yup from "yup";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import appAxios from "@/store/utils/appAxios";

//Store Tanımlaması
const store = useStore();

// Multi Language
const { t, te } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

const platform = store.state.platform;
// Validation Tanımlaması
const companyValidator = Yup.object().shape({
  customerName: Yup.string()
    .nullable()
    .required(translate("CustomerAdd_Valid_CompanyName")),
  fname: Yup.string()
    .nullable()
    .required(translate("CustomerAdd_Valid_FirstName")),
  lname: Yup.string()
    .nullable()
    .required(translate("CustomerAdd_Valid_LastName")),
  email: Yup.string()
    .nullable()
    .required(translate("CustomerAdd_Valid_EMail"))
    .email(translate("CustomerAdd_Valid_EMailFormat")),
});

//Değişkenler
const block = ref(false);
const title = ref("CustomersAdd_New");
const newTargetModalRef = ref(null);
const refForm = ref(null);
const loading = ref(false);
const customer = reactive({
  id: 0,
  name: null,
  firstname: null,
  lastname: null,
  email: null,
  phoneNumber: null,
  countryId: 0,
  cityId: 0,
  districtId: 0,
  address: null,
  description: null,
  published: true,
});

//Adres İşlemleri
store.dispatch("LanguageModule/GET_ALL_COUNTRY");
const CountryList = computed(
  () => store.getters["LanguageModule/_getCountryList"]
);
const CityList = computed(() => store.getters["LanguageModule/_getCityList"]);
const DistrictList = computed(
  () => store.getters["LanguageModule/_getDistrictList"]
);
const getCity = () => {
  customer.cityId = 0;
  customer.districtId = 0;
  store.dispatch("LanguageModule/GET_CITYS", customer.countryId);
};
const getDistrict = () => {
  customer.districtId = 0;
  store.dispatch("LanguageModule/GET_DISTRICT", customer.cityId);
};

//Watch, Props ve Emit
const props = defineProps({ UpdateItem: Number });
const emit = defineEmits(["propsNull"]);

watch(props, () => {
  if (props.UpdateItem !== null) {
    block.value = true;
    store
      .dispatch("CustomerModule/GET_CUSTOMER", props.UpdateItem)
      .then((response) => {
        if (response !== null) {
          title.value = response.Name;
          customer.countryId = response.CountryId;
          if (response.CountryId !== "" || response.CountryId !== null) {
            store.dispatch("LanguageModule/GET_CITYS", response.CountryId);
            customer.cityId = response.CityId;
          }
          if (response.CityId !== "" || response.CityId !== null) {
            store.dispatch("LanguageModule/GET_DISTRICT", response.CityId);
            customer.districtId = response.DistrictId;
          }
          customer.id = response.Id;
          customer.name = response.Name;
          customer.firstname = response.Firstname;
          customer.lastname = response.Lastname;
          customer.email = response.Email;
          customer.phoneNumber = response.PhoneNumber;
          customer.address = response.Address;
          customer.description = response.Description;
          customer.published = response.Published;
        }
        setTimeout(() => {
          block.value = false;
        }, 300);
      });
  }
});

//Modal İşlemleri
const cancelForm = () => {
  hideModal(newTargetModalRef.value);
};
const clearForm = () => {
  setTimeout(() => {
    customer.id = 0;
    customer.name = null;
    customer.firstname = null;
    customer.lastname = null;
    customer.email = null;
    customer.phoneNumber = null;
    customer.countryId = 0;
    customer.cityId = 0;
    customer.districtId = 0;
    customer.address = null;
    customer.description = null;
    customer.published = true;
    refForm.value.resetForm();
    emit("propsNull", saveOrUpader);
    title.value = "CustomersAdd_New";
  }, 300);
};

let saveOrUpader = false;
// Add ve Update İşlemleri
const onSubmit = (values, { resetForm }) => {
  loading.value = true;
  store.dispatch("CustomerModule/ADD_CUSTOMER", customer).then((response) => {
    if (response) {
      loading.value = false;
      saveOrUpader = true;
    } else {
      loading.value = false;
    }
  });

  cancelForm();
};

const updateCustomer = () => {
  loading.value = true;
  customer.id = props.UpdateItem;
  store
    .dispatch("CustomerModule/UPDATE_CUSTOMER", customer)
    .then((response) => {
      if (response) {
        loading.value = false;
        saveOrUpader = true;
      } else loading.value = false;
    });
  cancelForm();
};

onMounted(() => {
  document
    .getElementById("add-customer-modal")
    .addEventListener("hide.bs.modal", function () {
      clearForm();
    });
  document
    .getElementById("add-customer-modal")
    .addEventListener("show.bs.modal", function () {
      saveOrUpader = false;
    });
});
</script>

<style></style>
